import { Datalayer, DatalayerZone, isArray, LayerTypeId } from "../../../omnia"

import m = omnia.models

export function fixGeometryTypes(layer: Datalayer) {

    switch (layer.typeId) {

        case LayerTypeId.NutrientApplications:
        case LayerTypeId.NutrientRequirements:
        case LayerTypeId.SeedRate:
            return;

    }


    let invalidZones = layer.zones.map(z => {

        let geom = z.feature.getGeometry();

        let polygons = omnia.map.getPolygonsAsArray([geom]);

        if (isArray(polygons) && (polygons.length > 0)) {

            if ((polygons.length == 1) && (polygons[0] === geom)) {
                return null;
            }

            return {
                zone: z,
                polygons: polygons.sort((p1, p2) => p2.getArea() - p1.getArea()),
            }

        }

    }).filter(i => !!i);

    invalidZones.forEach(z => {

        z.zone.feature.setGeometry(z.polygons[0])

        for (let i = 1; i < z.polygons.length; i++) {
            cloneZone(layer, z.zone, z.polygons[i])
        }

    });

}

function cloneZone(layer: Datalayer, zone: DatalayerZone, geometry: any) {
    const clone = layer.createNewZoneWithGeometry(geometry)
    clone.value = zone.value
    return clone
}
